import toast from 'react-hot-toast';

const API_BASE_URL = process.env.REACT_APP_SERVER_HOST || "http://localhost:4000/";
const API_HOME_URL = process.env.REACT_APP_HOME || 'http://localhost:3000';

const camelToTitle = (str: string): string => {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .replace(/^./, (s) => s.toUpperCase());
};

const handleRequest = async (url: string, options: any) => {
    const response = await fetch(url, options);
    if (response.status === 401) {
        window.location.assign(API_HOME_URL);
        return null;
    }
    if (response.status === 422) {
        const data = await response.json();
        if (data.errors) {
            Object.entries(data.errors).forEach(([key, value]: [string, unknown]) => {
                if (Array.isArray(value)) {
                    (value as any[]).forEach((error: any) => {
                        toast.error(`${camelToTitle(key)}: ${error}`);
                    });
                } else if (typeof value === "string") {
                    toast.error(value);
                }
            });
        }
    }
    return response;
};

export const get = async (url: string, params: string = '') => {
    const fullUrl = `${API_BASE_URL}${url}?${params}`;
    const options = {
        method: 'GET',
        headers: {
            authorization: `Bearer ${sessionStorage.getItem('auth_token')}`,
        },
    };
    return handleRequest(fullUrl, options);
};

export const post = async (url: string, body: any = {}) => {
    const fullUrl = `${API_BASE_URL}${url}`;
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${sessionStorage.getItem('auth_token')}`,
        },
        body: JSON.stringify(body),
    };

    return handleRequest(fullUrl, options);
};

export const put = async (url: string, body: any) => {
    const fullUrl = `${API_BASE_URL}${url}`;
    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${sessionStorage.getItem('auth_token')}`,
        },
        body: JSON.stringify(body),
    };

    return handleRequest(fullUrl, options);
};

export const del = async (url: string) => {
    const fullUrl = `${API_BASE_URL}${url}`;
    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${sessionStorage.getItem('auth_token')}`,
        },
    };

    return handleRequest(fullUrl, options);
};

export const post_form_data = async (url: string, formData: FormData) => {
    const fullUrl = `${API_BASE_URL}${url}`;
    const options = {
        method: 'POST',
        headers: {
            authorization: `Bearer ${sessionStorage.getItem('auth_token')}`,
        },
        body: formData,
    };

    return handleRequest(fullUrl, options);
};

export const gen_link = (url: string, params: string = '') => {
    return `${API_BASE_URL}${url}?token=${sessionStorage.getItem('auth_token')}&${params}`;
};


